import { arrZeros } from '../../../fun-js-lib/arr';
import { isOrderedList, isUnorderedList } from './node-type';
import { breakChildrenIntoSpans } from './span';
import { indentPerDepth } from './line';
import { breakParagraphIntoLines } from "./break-paragraph";

/**
 * @param {ChildNode} paragraph
 * @param {CanvasRenderingContext2D} context
 * @param {number[]} linesWidths
 */
export function breakListIntoLines (paragraph, context, linesWidths) {
  /** @type {import('./line').Line[]} */
  let lines = [];
  const items = Array.from(paragraph.childNodes);
  // Used for marking ordered lists (i.e. 1., 2., 2.1, ...)
  let orderNumbers = arrZeros(MAX_DEPTH);
  items.forEach(item => {
    // @ts-ignore
    const nestingLevel = getDepth(item);
    stepLevels(orderNumbers, nestingLevel);
    const indent = nestingLevel * indentPerDepth + indentForNodeMark;
    const spans = breakChildrenIntoSpans(item);
    let newLines = breakParagraphIntoLines(context, spans, linesWidths, indent);
    newLines.forEach(line => {
      line.isOrderedList = isOrderedList(paragraph);
      line.isUnorderedList = isUnorderedList(paragraph);
      line.nestingLevel = nestingLevel;
      line.orderNumber = orderNumbers[nestingLevel];
    });
    lines = lines.concat(newLines);
  });
  return lines;
}

export const indentForNodeMark = 70

/**
 * Increase order number of nesting level (this number used for ordered lists)
 * @param {number[]} orderNumbers 
 * @param {number} nestingLevel 
 */
function stepLevels (orderNumbers, nestingLevel) {
  orderNumbers[nestingLevel]++
  for (let i = nestingLevel + 1; i < orderNumbers.length; ++i) {
    orderNumbers[i] = 0
  }
}

/**
 * @param {HTMLElement} listItem 
 */
function getDepth (listItem) {
  let stringToMatch = listItem.className +
    getAttributeString(listItem, 0) +
    getAttributeString(listItem, 1) +
    getAttributeString(listItem, 2)
  let matched = stringToMatch.match(/ql-indent-./)
  if (matched === null) {
    return 0
  } else {
    return +matched[0].match(/\d/)[0]
  }
}

/**
 * @param {HTMLElement} element 
 * @param {number} i 
 */
function getAttributeString (element, i) {
  const item = element.attributes.item(i)
  return item === null ? '' : item.name
}

const MAX_DEPTH = 8